import { LANGUAGES } from '@/utils'
import type { TypeLang } from '@/schema'

// Exception requested by client in Asana: Portuguese, Catalan, Basque and Galician are redirected to Spanish
const SPANISH_FALLBACK_LANGS = new Set(['pt', 'ca', 'eu', 'gl'])

export function getPreferredLang(acceptLanguage: string | null): TypeLang | null {
  if (!acceptLanguage) return null

  const parsed = acceptLanguage
    .split(',')
    .map(part => {
      const [lang, quality] = part.trim().split(';q=')
      return {
        lang: lang.trim().split('-')[0].toLowerCase(),
        q: quality ? parseFloat(quality) : 1,
      }
    })
    .sort((a, b) => b.q - a.q)

  for (const { lang } of parsed) {
    if (SPANISH_FALLBACK_LANGS.has(lang)) return 'es'
    if (LANGUAGES.includes(lang as TypeLang)) return lang as TypeLang
  }

  return null
}

export function getLangFromUrl(pathname: string): TypeLang | null {
  const segment = pathname.split('/')[1]
  if (!segment) return null
  return LANGUAGES.includes(segment as TypeLang) ? segment as TypeLang : null
}
